// removed by extract-text-webpack-plugin
module.exports = {"container":"flash-message__container___2Qpd8","container--success":"flash-message__container--success___3fef9","container--error":"flash-message__container--error___1PG-J","fadein-fadeout":"flash-message__fadein-fadeout___8rx2_","fadein":"flash-message__fadein___mm62r"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/common/flash-message.scss
// module id = 1306
// module chunks = 0